import React, { useState } from 'react'
import { CheckIcon } from '@heroicons/react/outline'
import TermsModal from './TermsModal'

const TermsAndConditions = ({ handleToggleTerms, agreedTerms }) => {
  const [visibleTermsModal, setVisibleTermsModal] = useState(false)
  const showTermsModal = (e) => {
    e.stopPropagation()
    e.preventDefault()
    setVisibleTermsModal(true)
  }
  const hideTermsModal = () => setVisibleTermsModal(false)

  return (
    <>
      <div className="flex items-center my-4" onClick={handleToggleTerms}>
        <div className="w-6 h-6 border-2 border-primary-light rounded bg-white text-primary-light">
          {agreedTerms && <CheckIcon />}
        </div>
        <div className="ml-4">
          I agree with the{' '}
          <span className="font-bold text-primary-light cursor-pointer" onClick={showTermsModal}>
            terms and conditions
          </span>
          *
        </div>
      </div>
      <TermsModal open={visibleTermsModal} handleClose={hideTermsModal} />
    </>
  )
}

export default TermsAndConditions
